export default __webpack_public_path__ + "static/media/warning--railroad-intersection--g4.7f8bcdfd.png";